
<form [formGroup]="formGroup">
  <div *ngIf='!useLabelReadOnly' [ngClass]="cssClass" class="form-group">
    <pt-input-label
      *ngIf="label"
      [label]="label"
      [inputId]="inputId"
      [isRequired]="isRequired"
      [help]="labelHelp"
      [helpType]="labelHelpType"
      [fontWeightBold]='fontWeightBold'
      style="display: contents">
      <ng-content></ng-content>
    </pt-input-label>


    <!--    [class.is-invalid]="formGroup.invalid && formGroup.touched"-->
<!--    [class.ng-invalid]="formGroup.invalid && formGroup.touched"-->
<!--    [class.ng-touched]=formGroup.touched-->
<!--    [class.ng-dirty]=formGroup.dirty-->
<!--    [class.ng-valid]=formGroup.valid-->
    <div
      class="form-control form-control-sm ng-select-single-control"
      [class.invalid-custom]="formGroup.invalid"
      [ngClass]='findOptionBorderColorCss()'>
      <ng-select
        class="ng-select--custom"
        formControlName="value"
        bindLabel="label"
        bindValue="value"
        appendTo="body"
        [id]="inputId"
        [clearable]="clearable"
        [searchable]="searchable"
        [placeholder]="placeholder"
        [notFoundText]='notFoundText'>
        <ng-container *ngFor="let option of options">
          <ng-option [disabled]="option.disabled" [ngClass]='option.cssClass' [value]="option.value">
            <span [ngClass]='option.cssClass' style="height: 25px;">{{ option.label | async }}</span>
          </ng-option>
        </ng-container>
      </ng-select>
    </div>
  </div>

  <ng-container *ngIf='useLabelReadOnly'>
    <div [ngClass]="cssClass" class="d-flex flex-column">
      <pt-input-label
        style="display: contents"
        [label]="label"
        [inputId]="inputId"
        [isRequired]="isRequired"
        [fontWeightBold]='fontWeightBold'
        [help]="labelHelp"
        [helpType]="labelHelpType"
        *ngIf="label && showInputLabelReadOnly">
      </pt-input-label>

      <span [class.fw-bold]="showInputLabelReadOnly"
            [class.ms-2]="showInputLabelReadOnly"
            [ngClass]='findOptionCssClass()'
            class="w-100">
        {{ findOptionLabel() | async }}
      </span>
    </div>
  </ng-container>
  <small [innerHTML]="help" class="form-text text-muted" id="ptWSelectHelp_{{controlName}}"></small>
</form>
